import React, { lazy, Fragment, Suspense, useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ProgressIndicator } from '@veneer/core';
import Center from 'src/components/Center';
import FlipperCheck from './hooks/flipperCheck';
import SubscriptionContext from './context/subscription';
import ClientLayout from './layout/client';
import ResupplyModelV3Layout from './layout/resupply-model-v3';

const Routes = () => {
  const { subscriptionContext } = useContext(SubscriptionContext);
  FlipperCheck();

  const routesConfig = [
    {
      exact: true,
      path: '/',
      component: () => <Redirect to="/billing" />,
    },
    {
      path: '/billing',
      component: lazy(() => import('src/views/billing')),
      layout: ClientLayout,
    },
    {
      path: '/safety-stock',
      component: lazy(() =>
        import('src/components/ResupplyModelV3/components/SafetyStock')
      ),
      layout: ResupplyModelV3Layout,
    },
    {
      path: '/initial-stock',
      component: lazy(() =>
        import('src/components/ResupplyModelV3/components/InitialStock')
      ),
      layout: ResupplyModelV3Layout,
    },
    {
      path: '/supplies',
      component: lazy(() => import('src/views/nrmSupplies')),
      layout: ClientLayout,
      disabled: /* !subscriptionContext.flipperContext.flipper */ true,
    },
    {
      path: '/supplies/ordered',
      component: lazy(() => import('src/views/supplies/ordered')),
      layout: ClientLayout,
      disabled: subscriptionContext.flipperContext.flipper,
    },
    {
      path: '/supplies/available',
      component: lazy(() => import('src/views/supplies/available')),
      layout: ClientLayout,
      disabled: subscriptionContext.flipperContext.flipper,
    },
    {
      path: '/supplies/in-device',
      component: lazy(() => import('src/views/supplies/in-device')),
      layout: ClientLayout,
      disabled: subscriptionContext.flipperContext.flipper,
    },
    {
      path: '/supplies/stock-alignment',
      component: lazy(() => import('src/views/supplies/stock-alignment')),
      layout: ClientLayout,
      disabled: subscriptionContext.flipperContext.flipper,
    },
  ];

  return (
    <Router>
      <Suspense
        fallback={
          <Center>
            <ProgressIndicator />
          </Center>
        }
      >
        <Switch>
          {routesConfig
            .filter((route) => !route.disabled)
            .map((route, key) => {
              const Layout = route.layout || Fragment;
              const Component = route.component;

              return (
                <Route
                  exact
                  key={key}
                  path={route.path}
                  render={(props) => (
                    <Layout>
                      <Component {...props} />
                    </Layout>
                  )}
                />
              );
            })}
        </Switch>
      </Suspense>
    </Router>
  );
};

export default Routes;
